import { useMutation, type UseMutationResult } from "@tanstack/react-query";
import type { ApiError, ApiResponse } from "../../../types/apiResponse";
import { createBill } from "../api/createBill";
import type { billPayload } from "../types";


export const useCreateBill = (): UseMutationResult<ApiResponse, ApiError, billPayload> => {
    return useMutation({
        mutationFn: createBill,
    })
}